import { toDataSourceRequestString } from "@progress/kendo-data-query";
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryAdminWithAuth } from "../api";
import type { ListAdminRawSaleRecordsResponse, ListAdminRawSaleRecordsRequest } from "../../contracts";

export const adminRawSaleRecordApi = createApi({
    reducerPath: "adminRawSaleRecordApi",
    baseQuery: baseQueryAdminWithAuth,
    tagTypes: ["AdminRawSaleRecords"],
    endpoints: builder => ({
        listAdminRawSaleRecords: builder.query<ListAdminRawSaleRecordsResponse, ListAdminRawSaleRecordsRequest>({
            query: body => ({
                url: `rawSaleRecord/list?${toDataSourceRequestString(body)}`,
                method: "POST",
                body
            }),
            providesTags: ["AdminRawSaleRecords"]
        })
    })
});

export const {
    useListAdminRawSaleRecordsQuery,
    useLazyListAdminRawSaleRecordsQuery
} = adminRawSaleRecordApi;
